import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
// mui
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
// import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
// component
import AvatarForm from '../mui/AvatarForm';
// import SFCopyIcon from '@/component/icons/sf-copy-icon';
// lib & store etc
import { ShortenAddr } from '@/lib/Shorten';
import { SFPalette } from '@/lib/color';
import { copy } from '@/lib/util';
import { inter } from '@/theme';
import { maskingEmail, maskingName } from '@/lib/Masking';
// hook
import { useWeb3AuthConnect, useWeb3AuthUser } from '@web3auth/modal/react';
import { useWeb3 } from '@/contexts/web3Provider';

export default function UserInfo({ colorTone = 'white' }: { colorTone?: 'white' | 'black' }) {
  const { t } = useTranslation();
  const [address, setAddress] = useState('');
  const [name, setName] = useState('');
  const { isConnected } = useWeb3AuthConnect();
  const { userInfo } = useWeb3AuthUser();
  const { address: addr } = useWeb3();

  useEffect(() => {
    if (userInfo && name === '') {
      (async () => {
        setName(userInfo?.email ? maskingEmail(userInfo?.email) : 'member');
        setAddress(addr);
      })();
    }

    return () => {};
  }, [userInfo, name]);

  return (
    <Stack mt={4} gap={1.5} direction="row" alignItems="center" color={colorTone === 'white' ? 'white' : 'inherit'}>
      <AvatarForm sxOptions={{ width: 32, height: 32, border: '2px solid white' }} />
      <Box>
        <Typography variant="h6">
          <strong>{name}</strong>
          {t('validation.yourBalance')}
        </Typography>
        <Stack direction="row" alignItems="center">
          <Typography
            variant="h6"
            fontFamily={inter.style.fontFamily}
            color={colorTone === 'black' ? SFPalette.grey2 : undefined}
          >
            <Button
              color="primary"
              variant="text"
              onClick={() => {
                copy(String(address));
                toast.success(`${t('toast.copyYourWallet')}`);
              }}
            >
              <strong style={{ color: colorTone === 'black' ? SFPalette.grey2 : 'white' }}>
                {ShortenAddr(String(address))} {t('button.copyWallet')}
              </strong>
            </Button>
          </Typography>
          {/* <IconButton
            sx={{
              p: 0.5,
            }}
            onClick={() => {
              copy(String(address));
              toast.success('지갑 주소가 복사되었습니다.');
            }}
          >
            <SFCopyIcon color={colorTone === 'black' ? SFPalette.grey2 : 'white'} />
          </IconButton> */}
        </Stack>
      </Box>
    </Stack>
  );
}
